module.exports = __webpack_public_path__ + "img/skull_4.b9bdaa16.png";